<template>
    <Container type="card-full" drankColor>
        <div class="view-container">
            <div class="view-box">
                <div class="view-row">
                    <div class="view-field">
                        <div class="view-label">项目名称</div>
                        <div class="view-content">{{project.projectname}}</div>
                    </div>
                </div>
                <div class="view-row">
                    <div class="view-field">
                        <div class="view-label">修改类型</div>
                        <div class="view-value">{{+pexchangetype===1?"初审":"评分"}}</div>
                    </div>
                </div>
                <el-form :model="pexchange" ref="ruleForm" label-position="right" class="mainfrom">
                        <div class="content">
                            <el-form-item label="申请理由"  prop="pexchangereason" verify  style="width:60%;">
                                <!--t-->
                                <el-input show-word-limit :maxlength="1000" type="textarea" :rows="5"
                                        v-model.trim="pexchange.pexchangereason"></el-input>
                            </el-form-item>
                        </div>
                        <div class="view-row">
                            <div class="view-field">
                                <div class="view-label"></div>
                                <div class="view-value">
                                    <el-button type='primary' @click="submitChangInfo">提交</el-button>
                                </div>
                            </div>
                        </div>
                </el-form>
            </div>
        </div>
    </Container>
</template>
<script>
  import request from '@/utils/request'

  export default {
    name: 'exApplyForModificationFrom',
    data () {
      return {
          pexchange:{},
          pexchangetype:{},///修改类型1：初审，2：评分
          project:{}
      }
    },
    created () {
    },
    activated(){
        this.init()
        this.getMoldel()
    },
    methods: {
        init(){
            this.pexchange = {}
            this.pexchangetype = this.$route.params.pexchangetype
        },
        async getMoldel(){
            let res = await request({
                method: 'get',
                url: 'expert/findProjectById',
                params: {projectid: this.$store.getters.expertLoginUser.pexpertprojectid}
            })
            this.project = res
        },
        close() {
            this.$store.commit('close_expert_tab', {routeName: this.$route.name, vm: this, newRouteName: ''})
        },
        async submitChangInfo(){
            if(!this.pexchange.pexchangereason){
                this.$message.warning('请填写申请理由')
                return
            }
            let from = {}
            from.projectid = this.$store.getters.expertLoginUser.pexpertprojectid
            from.pexchangepexpertid =this.$store.getters.expertLoginUser.pexpertid
            from.pexchangetype = this.pexchangetype
            from.pexchangereason = this.pexchange.pexchangereason
            let res = await request({
                method: 'post',
                url: 'expert/changPexInfo',
                data: from
            })
            if(+res.issuccess === 3){
                this.$message.warning('你有改分申请未审核，请耐心等候')
                return
            }
            
            if(+res.issuccess === 1){
                this.$message.warning('会签已提交，不可提交申请')
                return
            }
            if(+res.issuccess === 2){
                this.$message.success('申请成功')
                await this.regNotice()
                this.close()
                return
            }
        },
        async regNotice(){
            let model = {}
            model.projectid = this.$store.getters.expertLoginUser.pexpertprojectid
            model.cosid = this.$store.getters.expertLoginUser.cosid

            await request({
                url: 'expert/Application',
                method: "post",
                data: model
            })
        }
    }
  }
</script>

<style lang="scss" scoped>

</style>